// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';
import balanceText from 'balance-text';
import { classify } from './utils/helpers';

// polyfills
// import fetch from 'unfetch';
// import './utils/polyfills'; (includes Array.findIndex && Array.find)

// utils & data
import data from './data/data.json';

// styles
import './styles/graphic.scss';


// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw });

window.onload = () => {
  const { pymChild } = window;
  pymChild.sendHeight();
};

function draw() {
  const thread = select('#graphic').select('.frame').html('');
  let speaker;

  data.forEach((row) => {
    // console.log(d);

    if (row.type == 'timestamp') {
      thread.append('div')
        .attr('class', 'timestamp')
        .append('h3')
        .html(row.content);
    }

    if (row.type == 'message') {
      thread.append('div')
        .attr('class', `message ${classify(row.speaker)}`)
        .append('p')
        .html(row.content);
    }

    if (row.type == 'name') {
      thread.append('div')
        .attr('class', `name ${classify(row.speaker)}`)
        .append('p')
        .html(row.content);
    }
  });

  balanceText('.message > p');
}
